import {
  clsx_default
} from "../../../../chunk-QJVDQ4DQ.mjs";
import "../../../../chunk-D57E6H3M.mjs";

// src/components/composite/Timeline/ShimmerText/ShimmerText.tsx
import { jsx } from "react/jsx-runtime";
function ShimmerText({ children, active = true, className, style }) {
  if (!active) {
    return children;
  }
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: clsx_default("buyscout-shimmer-text", className),
      style,
      children
    }
  );
}
ShimmerText.displayName = "ShimmerText";
export {
  ShimmerText
};
//# sourceMappingURL=ShimmerText.mjs.map